var _rect, _rect2, _path, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExercise03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6875,
    y: 0.53125,
    width: 350,
    height: 233,
    fill: "#DC7D94"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 181.977,
    y: 123.074,
    width: 132.639,
    height: 9.72292,
    rx: 2,
    fill: "#A1A6AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314.616 130.797V125.074C314.616 123.97 313.72 123.074 312.616 123.074H310.125C309.911 123.074 309.719 123.102 309.515 123.167C299.152 126.437 251.468 132.797 220.316 132.797H312.616C313.72 132.797 314.616 131.902 314.616 130.797Z",
    fill: "#848F9B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 232.617,
    y: 122.77,
    width: 31.357,
    height: 10.3263,
    rx: 1,
    fill: "#27435E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.832 93.9922C205.832 92.8876 206.727 91.9922 207.832 91.9922H217.974C219.079 91.9922 219.974 92.8876 219.974 93.9922V161.876C219.974 162.981 219.079 163.876 217.974 163.876H207.832C206.727 163.876 205.832 162.981 205.832 161.876V93.9922Z",
    fill: "#3C6C98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.975 161.877V102.711L208.889 163.877H217.975C219.079 163.877 219.975 162.982 219.975 161.877Z",
    fill: "#2B4965"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191.689 101.945C191.689 100.841 192.585 99.9453 193.689 99.9453H205.832V155.925H193.689C192.585 155.925 191.689 155.029 191.689 153.925V101.945Z",
    fill: "#3C6C98"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M290.762 99.9453H302.904C304.008 99.9453 304.904 100.841 304.904 101.945V153.925C304.904 155.029 304.008 155.925 302.904 155.925H290.762V99.9453Z",
    fill: "#3C6C98"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M276.619 93.9922C276.619 92.8876 277.515 91.9922 278.619 91.9922H288.761C289.866 91.9922 290.761 92.8876 290.761 93.9922V161.876C290.761 162.981 289.866 163.876 288.761 163.876H278.619C277.515 163.876 276.619 162.981 276.619 161.876V93.9922Z",
    fill: "#3C6C98"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M205.832 155.923V105.27L194.746 155.923H205.832Z",
    fill: "#2B4965"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M276.617 161.877V102.711L287.703 163.877H278.617C277.512 163.877 276.617 162.982 276.617 161.877Z",
    fill: "#2B4965"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M290.76 155.923V105.27L301.846 155.923H290.76Z",
    fill: "#2B4965"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise03);
export default __webpack_public_path__ + "static/media/exercise_03.064b910a25ac03ab175b825c2af2dc28.svg";
export { ForwardRef as ReactComponent };